// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const RecipeReviewForm = registerClientReference(
    function() { throw new Error("Attempted to call RecipeReviewForm() from the server but RecipeReviewForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/recipes/recipe-review-form.tsx",
    "RecipeReviewForm",
);
